import { Permission } from './permission.model';
export class Role {
  [x: string]: any;
  constructor(name?: string, description?: string, access?: string, username?: string) {
    this.Name = name;
    this.Description = description;
    this.UserName = username;
    this.Access = access;
  }
  public Id: string;
  public Name: string;
  public Description: string;
  public UsersCount: string;
  public Permissions: Permission[];
  public Access: string;
  public UserName: string;
  public DisplayName: string;
}
